import { generatePath } from 'react-router';
import { call, select, takeLatest, put } from 'redux-saga/effects';

import { SELECT_DEALER } from 'constants/ActionTypes';
import { PATH } from 'constants/RoutesConstants';
import { scopeToPage } from 'modules/app/sagas/utils';
import * as actions from 'modules/contactLists/actions/core';
import * as types from 'modules/contactLists/actionTypes';
import { DASHBOARD_SOURCE } from 'modules/contactLists/constants';
import { getBaseRequestParams } from 'modules/contactLists/selectors/dashboard';
import { navigate } from 'modules/router/navigate';

const onFilterChange = ({ type }) =>
  [
    SELECT_DEALER,
    types.SET_CONTACT_LIST_DASHBOARD_FILTER,
    types.SET_CONTACT_LIST_DASHBOARD_FILTERS,
    types.CLEAR_CONTACT_LIST_DASHBOARD_FILTER,
    types.REMOVE_CONTACT_LIST_DASHBOARD_FILTER,
  ].includes(type);

function* refreshDashboard() {
  const params = yield select(getBaseRequestParams);
  yield put(actions.fetchContactLists(params, { source: DASHBOARD_SOURCE }));
}

function* afterCreateContactList({ payload: contactList }) {
  yield call(navigate, generatePath(PATH.CONTACT_LISTS_DETAILS.path, { contactListId: contactList.id }));
}

function* onDashboardWorker() {
  yield call(refreshDashboard);
  yield takeLatest(onFilterChange, refreshDashboard);
  yield takeLatest(types.CREATE_CONTACT_LIST_SUCCESS, afterCreateContactList);
}

export default function* contactListsDashboardSaga() {
  yield scopeToPage([PATH.CONTACT_LISTS_DASHBOARD], onDashboardWorker);
}
